import { VxModelsLogo, VxModelsName } from '@campoint/odi-ui-icons';
import {
  Button,
  Center,
  CenterProps,
  Heading,
  Icon,
  Spacer,
  Text,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { FullscreenPageLayout } from '../../components/Layout/FullscreenPageLayout';
import ScrollToTopOnMount from '../../components/Layout/ScrollToTopOnMount';
import useHistoryWithStorage from '../../hooks/useHistoryWithStorage';
import { routes } from '../../routes/routesConfig';

const ErrorPageButtonFooter: React.FC = () => {
  const history = useHistory();
  const historyWithStorage = useHistoryWithStorage();
  const { t } = useTranslation(['errorPage']);

  const routeToStart = () => history.push(routes.home.path);
  const routeToSupport = () => historyWithStorage.push(routes.help.path);

  return (
    <VStack gap="4" alignItems="center">
      <Button children={t('errorPage:primaryButton')} onClick={routeToStart} />
      <Button
        variant="ghost"
        children={t('errorPage:supportButton')}
        onClick={routeToSupport}
      />
    </VStack>
  );
};
const BrandLogo: React.FC<CenterProps> = (props) => (
  <Center role="banner" {...props}>
    <Icon as={VxModelsLogo} boxSize="icon.lg" color="vxModels.500" />
    <Icon as={VxModelsName} h="icon.lg" w="24" color="inherit" />
  </Center>
);
const ErrorPage: React.FC = (props) => {
  const { t } = useTranslation(['errorPage']);
  return (
    <FullscreenPageLayout>
      <ScrollToTopOnMount />
      <VStack
        bg={'coldGray.900'}
        color={'coldGray.50'}
        left={0}
        right={0}
        top={0}
        bottom={0}
        position={'absolute'}
      >
        <BrandLogo mt={4} />
        <Spacer />
        <VStack mb={8}>
          <VStack mb={4}>
            <Heading>{t('errorPage:headline')}</Heading>
            <Text>{t('errorPage:subHeadline')}</Text>
          </VStack>
          <ErrorPageButtonFooter />
        </VStack>
      </VStack>
    </FullscreenPageLayout>
  );
};

export default ErrorPage;
